import {
  ref,
  onMounted,
  defineComponent,
  computed,
} from "@vue/composition-api";

export default defineComponent({
  name: "circularPercentageChart",
  props: {
    cpcPercentage: {
      type: Number,
      required: true,
    },
  },

  setup(props, _ctx) {
    const strDashArray = computed(() => {
      return `${props.cpcPercentage}, 100`;
    });

    const percentageLabel = computed(() => {
      return `${props.cpcPercentage} %`;
    });

    return {
      strDashArray,
      percentageLabel,
    };
  },
});
